import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

interface SidebarNavProps {
  collapsed?: boolean;
}

export const SidebarNav = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<SidebarNavProps>(({ theme, collapsed }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: collapsed ? '20px 0 40px' : '35px 32px 40px',
  background:
    'linear-gradient(to bottom, rgba(0, 45, 28, 1), rgba(3, 12, 22, 1))',
  height: '100%',
  width: '100%',
  boxSizing: 'border-box',
  position: 'relative',
  transition: 'padding 0.3s ease',
  overflowX: 'hidden',
  overflowY: 'auto',

  h1: {
    marginBottom: 0,
    alignSelf: collapsed ? 'center' : 'flex-start',
    color: 'rgba(30, 237, 159, 1)',
    marginLeft: '0',
    fontSize: collapsed ? '0' : '2.5rem',
    fontWeight: 600,
    transition: 'all 0.3s ease',
    opacity: collapsed ? 0 : 1,
    height: collapsed ? '0' : 'auto',
    overflow: 'visible',
    whiteSpace: 'nowrap',
    minHeight: collapsed ? '0' : '3rem',
    lineHeight: '1.2',
  },

  [theme.breakpoints.down('md')]: {
    padding: collapsed ? '20px 0 40px' : '35px 20px 40px',
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: '10px 10px 60px 40px',
    flex: 1,
    minHeight: 0,
    maxHeight: 'calc(100dvh - 60px - var(--kipify-topbar-height, 0px))',
    overflowY: 'auto',
    overflowX: 'hidden',
    overscrollBehaviorY: 'contain',
    touchAction: 'pan-y',
    WebkitOverflowScrolling: 'touch',

    h1: {
      display: 'none',
    },
  },
}));

interface NavLinksProps {
  collapsed?: boolean;
}

export const NavLinks = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<NavLinksProps>(({ collapsed }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: collapsed ? '8px' : '10px',
  flexGrow: 1,
  alignSelf: 'flex-start',
  width: '100%',
  transition: 'gap 0.3s ease',
  padding: collapsed ? '0 8px' : '0',

  'a:last-of-type': {
    marginTop: 'auto',
  },
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  display: 'none',
  width: 'fit-content',
  alignSelf: 'flex-end',
  position: 'absolute',
  top: '10px',
  right: '10px',

  [theme.breakpoints.down('sm')]: {
    display: 'flex',
  },
}));

interface ToggleButtonProps {
  collapsed?: boolean;
}

export const ToggleButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<ToggleButtonProps>(({ theme, collapsed }) => ({
  position: 'absolute',
  top: collapsed ? 'auto' : '20px',
  bottom: collapsed ? 'auto' : 'auto',
  right: collapsed ? 'auto' : '8px',
  transform: collapsed ? 'none' : 'none',
  width: '36px',
  height: '36px',
  color: 'rgba(255, 255, 255, 0.8)',
  backgroundColor: 'rgba(255, 255, 255, 0.08)',
  borderRadius: '8px',
  transition: 'all 0.3s ease',
  zIndex: 10,
  border: '1px solid rgba(255, 255, 255, 0.1)',

  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    color: 'rgba(30, 237, 159, 1)',
    borderColor: 'rgba(30, 237, 159, 0.3)',
  },

  '& .MuiSvgIcon-root': {
    fontSize: '20px',
  },

  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));
